/*
MyPass Ski Work flow API calls
    -getWorkFlow:   extracts the wf data from localStorage and updates callers's screenData state
                    should be called in componentDidMount()
                    in case of processing the data after state update, call by 'async componentDidMount()'
    -modifyWorkflow:    modifying the workflow object in the storage for current screen
                        'screenData' state needs to updated in the screen to prevent server update and call for getting changes
                        server needs to be updated at the same time(in modifyWorkflow)

*/

import { create, state, transition, getHelpMsg, awsState } from '../libs/fetch';
import Cookies from 'universal-cookie';
import { Config } from '../Config';
// import { getRouteName } from '../Utils';
import tr from './tr';
import FirebaseLogger from './FirebaseLogger';
const cookies = new Cookies();
const START = true;
const STOP = false;

const defaultTimeout = 10000;
const PayStateTimeOut = 60000;
/*
get acess_token
*/

var access_token = cookies.get('access_token');

export default class MPWorkFlow {

    static myInstance = null;
    _fixedParams = null;
    /**
     * @returns {MPWorkFlow}
     */
    static getInstance() {
        if (MPWorkFlow.myInstance == null) {
            MPWorkFlow.myInstance = new MPWorkFlow();
        }

        return this.myInstance;
    }

    _getFixedParams() {
        return this._fixedParams = {
            service: "sci",
            portal: 'sci',
            // workflow: 'skicart',
            workflow: this._getWorkFlowName(),
            platform: Config.platform,
        }
    }

    _setWorkFlowName(wf) {
        return cookies.set('workflow', wf);
    }
    _getWorkFlowName() {
        return cookies.get('workflow');
    }

    async workflowCreat(that, params) {
        try {
            this._setWorkFlowName(params.workflow);
            access_token = cookies.get('access_token');
            that.setState({ workFlowInProgress: true });
            let timeout = new this._checkForTimeOut(that);
            timeout.start();
            let url = new URL(document.URL);
            url = url.href.replace('#', '/');
            let code = (new URL(url)).searchParams.get('w');
            let _params = Object.assign(this._getFixedParams(), params);
            if(!code) code = localStorage.getItem('welcomecode');
            if(code) _params.params = `welcomecode=${code}`;

            // Add coupon parameter for skicart workflow
            if(params.workflow === 'skicart') {
                let coupon = (new URL(url)).searchParams.get('coupon');
                if(!coupon) coupon = localStorage.getItem('coupon');
                if(coupon) {
                    _params.coupon = coupon;
                }
            }

            //console.log("[workflow] @workflowCreat #_params", _params, access_token);
            let response = await create(that, access_token, _params)
            timeout.stop();
            that.setState({ workFlowInProgress: false });
            //console.log("[workflow] @workflowCreat @response: ", response);
            // if(!response) this.logout(that);
            return response;
        } catch (error) {
            //console.log("[workflow] @workflowCreat @error: ", error);
        }
    }

    async workflowState(that, params) {
        //console.log("[workflow] @workflowState ", params);
        if (that.state.workFlowInProgress) return;
        if (params && params.state_data) {
            params.state_data = JSON.stringify(params.state_data);
            //console.log("[workflow] @workflowState #params.state_data", params.state_data);
        }
        that.setState({ workFlowInProgress: true });
        let timeout = new this._checkForTimeOut(that);
        timeout.start();
        //send data by 'state_data' param
        let _params = Object.assign(this._getFixedParams(), params);
        if (!params) {
            delete _params.state_data;
            delete _params.to_state;
        }

        //console.log("[workflow] @workflowState #_params", _params, access_token);
        let response = await state(that, access_token, _params);
        timeout.stop();
        that.setState({ workFlowInProgress: false });
        //console.log("[workflow] @workflowState @response: ", response);
        // if(!response) this.logout(that);
        if (response.status === "fail") {
            // getting the correct screen(stage/state) to go
            that.setState({
                helpShow: true,
                helpMessage: response.message
            });
        }
        return response;
    }

    async workflowTransition(that, params) {
        that.setState({ workFlowInProgress: true });
        let timeout = new this._checkForTimeOut(that);
        console.log("[workflow] @workflowTransition #params", params);
        timeout.start((params.to_state === "Pay" || "ACPay") ? PayStateTimeOut : defaultTimeout);
        //send next screen by 'to_state' param
        let _params = Object.assign(this._getFixedParams(), params);
        //console.log("[workflow] @workflowTransition #_params", _params, access_token);
        let response = await transition(that, access_token, _params);
        console.log("[workflow] @workflowTransition @response: ", response);
        that.setState({ workFlowInProgress: false });
        timeout.stop();
        //console.log("[workflow] @workflowTransition @response: ", response);
        // if(!response) this.logout(that);
        if (response.status === "fail") {
            // getting the correct screen(stage/state) to go
            this.getLastState(that);
        }else{
            // FirebaseLogger.getInstance().regEvent(params.to_state, {}, "Navigate");
        }
        return response;
    }

    async workflowHelp(that, params) {
        that.setState({ workFlowInProgress: true });
        let timeout = new this._checkForTimeOut(that);
        timeout.start();
        //send data by 'state_data' param
        let _params = Object.assign(this._getFixedParams(), params);
        //console.log("[workflow] @workflowHelp #_params", _params, access_token);
        let response = await getHelpMsg(that, access_token, _params);
        timeout.stop();
        that.setState({ workFlowInProgress: false });
        //console.log("[workflow] @workflowHelp @response: ", response);
        // if(!response) this.logout(that);
        if (response && response.message) {
            that.setState({
                helpShow: true,
                helpMessage: response.message
            });
        }
    }
    /* local functions */
    // non-server APIs
    //  no need for that.setState({ workFlowInProgress: true });

    // completely overrides the workflow object in the storage
    updateWorkflow(that, data) {
        this._checkForError(that, data);
        localStorage.setItem('workflow', JSON.stringify(data));
    }

    _checkForError(that, data) {
        try {
            //console.log("[workflow] @_checkForError @data: ", data);
            let currentWf = data.states[data.currentstate];
            //console.log("[workflow] @_checkForError @currentWf: ", currentWf);
            // check for error only in update case
            if (currentWf.error) {
                that.setState({
                    helpShow: true,
                    helpMessage: currentWf.error
                });
            }
        } catch (error) {
            alert("System Error in workflow");
        }
    }

    // modifying the workflow object in the storage for current screen and re-updating the screen
    modifyWorkflow(that, stage, screenData) {
        // console.log("[workflow] @modifyWorkflow: ", stage, screenData);
        try {
            let wf = JSON.parse(localStorage.getItem('workflow'));
            // console.log("[workflow] @modifyWorkflow: ", wf);
            wf.states[stage] = screenData;
            // console.log("[workflow] @modifyWorkflow:after ", wf);
            localStorage.setItem('workflow', JSON.stringify(wf));
            this.getWorkFlow(that, stage);
        } catch (error) {
            console.warn("[workflow] @getWorkFlow error: ", error);
        }
    }


    // updates callers's screenData state
    getWorkFlow(that, stage) {
        try {
            let _wf = localStorage.getItem('workflow');
            if (_wf) {
                let wf = JSON.parse(_wf);
                console.log("[workflow] @getWorkFlow wf: ", wf);
                that.setState({ screenData: wf.states[stage] });
            }
            else {
                return null;
            }
        } catch (error) {
            console.warn("[workflow] @getWorkFlow error: ", error);
            return null;
        }
    }

    async getLastState(that) {
        console.warn("[workflow] @getLastState");
        // calling state with no params to get the current screen
        let resp = await this.workflowState(that);
        //console.log("[workflow] @getLastState #resp", resp);
        if (!resp) return;
        if (resp.status === "success") {
            // updating localStorage
            this.updateWorkflow(that, resp.data);
            // updating current screen
            let nextScreen = this.getRouteName(resp.data.currentstate);
            return that.props.history.push(nextScreen);
        } else if (resp.status === "fail") {
            return that.setState({ workFlowInProgress: false, isLoading: false, errorFlg: true, errmsg: resp.message });
        }
    }

    _checkForTimeOut(that) {
        this.start = function (timeout = defaultTimeout) {
            //console.log("[workflow] @_checkForTimeOut #start");
            this.KO = setTimeout(() => {
                //console.log("[workflow] @_checkForTimeOut #setTimeout");
                // no response arrived so far
                // notifying user
                that.setState({
                    workFlowInProgress: false,
                    isLoading: false,
                    errorFlg: true,
                    errmsg: tr.t("timeoutMessage")
                });
            }, timeout);
        }
        this.stop = function () {
            //console.log("[workflow] @_checkForTimeOut #stop");
            clearTimeout(this.KO);
        }
    }

    getStageName(stage) {
        if (this._getWorkFlowName() === "skicart") return stage;
        return "AC" + stage; // for additional card workflow screen names are changed
    }

    getRouteName(stageName){
        const stages = {
            Exit: "/",
            Have: "WelcomeScreen",
            Card: "resorts",
            Cart: "cart",
            CardId: "activate-card",
            Ship: "delivery-method",
            Skier: "config-card",
            Ship: "delivery-method",
            Address: "delivery-address",
            Pay: "transaction-confirm",
            ACHave: "WelcomeScreen",
            ACCard: "resorts",
            ACCart: "cart",
            ACCardId: "activate-card",
            ACShip: "delivery-method",
            ACSkier: "config-card",
            ACShip: "delivery-method",
            ACAddress: "delivery-address",
            ACPay: "transaction-confirm",
        }
        return stages[stageName];
    }
}




// WEBPACK FOOTER //
// ./src/libs/workflow.js